import { useState } from 'react';

/** @param {Array<React.ReactNode>} steps */
function useMultiStepForm(steps) {
  const [currentStep, setCurrentStep] = useState(1);

  function previousStep() {
    if (currentStep - 1 > 0) setCurrentStep(currentStep => currentStep - 1);
  }

  function nextStep() {
    if (currentStep + 1 <= steps.length)
      setCurrentStep(currentStep => currentStep + 1);
  }

  function stepTo(value) {
    if (value <= steps.length && value > 0) setCurrentStep(value);
  }

  const CurrentStep = steps[currentStep - 1];

  return {
    stepTo,
    CurrentStep,
    previousStep,
    nextStep,
    currentStep,
    totalSteps: steps.length,
    isFirstStep: currentStep === 1,
    isLastStep: currentStep === steps.length + 1,
  };
}

export default useMultiStepForm;
